module.exports = __webpack_public_path__ + "static/media/optima-seguros-pin.20dc9188.svg";